class ComponentLoadMore extends Theme.Component {
  #loading = false;

  connectedCallback() {
    super.connectedCallback();

    this.defineElements({ button: "[data-element='button']" });

    this.addDirectEvent("click", this, this.load);
  }

  get root() {
    return this.closest("collection-grid");
  }

  get grid() {
    return this.root?.querySelector(".collection-remainder .collection-grid");
  }

  load(event) {
    if (!event.target.closest("[data-element='button']") || this.#loading || !this.dataset.nextUrl) {
      return;
    }

    event.preventDefault();

    const root = this.root;
    const grid = this.grid;

    if (!root || !grid) {
      return;
    }

    this.#loading = true;
    this.classList.add("state--loading");
    this.elements.button.setAttribute("aria-busy", "true");

    const url = new URL(this.dataset.nextUrl, window.location.origin);

    url.searchParams.set("section_id", root.id);

    fetch(url.href)
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Load more request failed with status ${response.status}`);
        }

        return response.text();
      })
      .then((html) => {
        const next = new DOMParser().parseFromString(html, "text/html").getElementById(root.id);

        if (!next) {
          throw new Error(`Load more response is missing #${root.id}`);
        }

        const items = next.querySelector(".collection-remainder .collection-grid");

        if (items) {
          const seen = new Set(
            [...grid.querySelectorAll("[data-product-group]")]
              .map((card) => card.dataset.productGroup)
              .filter(Boolean)
          );

          const appended = [...items.children].filter((item) => {
            const handle = item.dataset.productGroup;

            if (!handle) {
              return true;
            }

            if (seen.has(handle)) {
              return false;
            }

            seen.add(handle);

            return true;
          });

          grid.append(...appended);
        }

        const following = next.querySelector("component-load-more");

        if (following) {
          this.dataset.nextUrl = following.dataset.nextUrl;
          this.elements.button.href = following.dataset.nextUrl;
        } else {
          this.remove();
        }

        this.dispatchEvent(new CustomEvent("loadmore:appended", { bubbles: true }));
      })
      .catch((error) => {
        console.error(error);
        window.location.href = this.dataset.nextUrl;
      })
      .finally(() => {
        this.#loading = false;
        this.classList.remove("state--loading");
        this.elements.button?.removeAttribute("aria-busy");
      });
  }
}

customElements.define("component-load-more", ComponentLoadMore);
